import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <AboutSection />
        <RankingSection />
        <FeaturesSection />
        <CardsSection />
        <TopicsSection />
        <AppSection />
        <IndexSection />
        <CommentsSection />
        <CarouselSection />
        <FAQSection />
        <ContactSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}